export default "__VITE_ASSET__BrVAZ8pJ__"